import React, { useState } from "react";
import { MdErrorOutline } from "react-icons/md";

interface EmailFormatValidationProps {
  text: string;
  setText: (value: string) => void;
  className?: any;
  required?: boolean;
  label?: string;
  placeholder?: string;
}

const EmailFormatValidation = ({
  text,
  setText,
  className = {
    parentDiv: "",
    label: "font-semibold text-sm",
    input:
      "w-full rounded py-2 px-4 mt-2 border-2 text-sm text-black outline-tertiary"
  },
  required = false,
  label = "Email",
  placeholder = "Enter Email"
}: EmailFormatValidationProps) => {
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    setText(value);

    const isValid =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/.test(value);

    if (value && !isValid) {
      setError("Please enter a valid email address");
      e.target.setCustomValidity("Please enter a valid email address");
    } else {
      setError("");
      e.target.setCustomValidity("");
    }
  };

  return (
    <div className={className.parentDiv}>
      <label className={className.label}>
  {label}
</label>

<input
  type="email"
  placeholder={placeholder}
  className={className.input}
  value={text}
  onChange={handleChange}
  required={required}
  onInvalid={(e) =>
    (e.currentTarget as HTMLInputElement).setCustomValidity(
      "Please enter a valid email address"
    )
  }
  onInput={(e) =>
    (e.currentTarget as HTMLInputElement).setCustomValidity("")
  }
/>
      {error && (
        <div className="flex items-center mt-2 text-xs text-red-500">
          <MdErrorOutline className="mr-1" style={{ fontSize: 16 }} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default EmailFormatValidation;